import * as React from 'react';
import { Config } from "../../helper";
import {
  buildExplanationPage, buildSummaryPage,
  disableNextButton,
  enableNextButton,
  highlightElement,
  onTextMarkdownHandler, pageHandler
} from "../../quiz-helper";
import { Model } from "survey-core";
import { css } from "../../../Webform";
import { Survey } from "survey-react-ui";
import { fetchQuizForm } from "../../api";

export default function QuizSummary(props) {
  const {
    submission: submissionID,
    formId,
    userData = {},
    dataToSubmit = {}
  } = props;

  let submissionData = {};
  if (userData) {
    submissionData = userData?.submission_data;
  }

  const [survey, setSurvey] = React.useState(null);

  React.useEffect(() => {
    if (!formId) {
      return;
    }

    fetchQuizForm(formId)
      .then(([data]) => {
        const pagesWithExplanation = [];
        let index = 0;
        for (const page of data?.pages || []) {
          const explanationPage = buildSummaryPage({...page}, index);

          const pageIndex = index;
          explanationPage.elements = explanationPage.elements.filter(el => {
            const {name, type} = el;
            switch (type) {
              case 'radiogroup':
              case 'dropdown':
                return true;
              case 'html':
                return !name.endsWith('--question-copy') && !name.endsWith('--answer-status');
              default:
                return false;
            }
          });

          explanationPage.elements.forEach(el => {
            const {type, correctAnswer, choices, name} = el;
            switch (type) {
              case 'radiogroup':
              case 'dropdown':
                setTimeout(() => {
                  if (correctAnswer) {
                    const correctChoice = choices.find(item => Array.isArray(correctAnswer) ? correctAnswer.includes[item.value] : item.value === correctAnswer);
                    const answerElement = document.querySelector(`[data-question-answer="${name.replaceAll('--question-copy', '')}"]`);
                    answerElement.classList.add('answer');
                    answerElement.innerHTML = `<div><span>${Config.I18n.Quiz.AnswerNumber(pageIndex + 1)}</span> <span class='answer-text'>${correctChoice.text}</span></div>`;
                  }
                }, 300);
                break;
            }
          });

          pagesWithExplanation.push({...explanationPage});
          index += 1;
        }

        const explanationPageElements = [];
        for (const explanationPage of pagesWithExplanation) {
          for (const el of explanationPage.elements) {
            explanationPageElements.push(el);
          }
        }

        data.pages = [
          {
            name: 'explanation-page',
            elements: [...explanationPageElements],
          }
        ];

        let model = new Model(data);

        model.showPrevButton = false;

        model.onTextMarkdown.add(onTextMarkdownHandler);
        model.onAfterRenderPage.add(disableNextButton);
        model.onValueChanged.add(enableNextButton);
        model.onCurrentPageChanged.add(pageHandler);
        model.onAfterRenderQuestion.add(highlightElement);

        setSurvey(model);
      }).catch(error => {
      console.log(error);
    });
  }, [formId]);

  const wrapperEl = React.useRef(null);

  const toggleSize = () => wrapperEl.current.classList.toggle('expanded');

  if (!survey) {
    return null;
  }

  return (
    <div className='quiz-summary-wrapper' ref={wrapperEl}>
      <div className='quiz-summary'>
        <h2 className='h--small mb-4 quiz-summary__header'>Assessment Summary</h2>

        <Survey model={survey} css={css}/>
      </div>
      <button className='quiz-summary-wrapper__toggler' type='button' onClick={toggleSize}>
        {Config.I18n.Action.ReadAll}
      </button>
    </div>
  );
}
